export default __webpack_public_path__ + "static/media/characters_left.17f0ce80.svg";